var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landscape--warning"},[_c('asset-v3',{attrs:{"dir":"context","name":"onboarding-landscape.svg"}}),_c('p',{staticClass:"gray-900 body-semi-bold text-center"},[_vm._v(" Para prosseguir, coloque seu celular na posição vertical ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }